var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemeComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,0C12.56,0,0,12.56,0,28,0,35.15,2.66,41.89,7.51,47.08L.29,54.29c-.29,.29-.37,.72-.22,1.09,.15,.37,.52,.62,.92,.62H28c15.44,0,28-12.56,28-28S43.44,0,28,0Zm0,54H3.41l6.2-6.2c.19-.19,.29-.44,.29-.71s-.11-.52-.29-.71c-4.91-4.9-7.62-11.43-7.62-18.38C2,13.66,13.66,2,28,2s26,11.66,26,26-11.66,26-26,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,18.76H19.74c-.55,0-1,.45-1,1s.45,1,1,1h16.76c.55,0,1-.45,1-1s-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,27H19.74c-.55,0-1,.45-1,1s.45,1,1,1h16.76c.55,0,1-.45,1-1s-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,35.24h-10.96c-.55,0-1,.45-1,1s.45,1,1,1h10.96c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeComments);
export default __webpack_public_path__ + "static/media/theme-comments.39231350d41e6899b54d43342185b6e5.svg";
export { ForwardRef as ReactComponent };